// The bridge between the framework's client router and the consented tracker.
//
// The tracker lives in a bundle of its own, outside the app, because most of
// this site ships no client bundle at all (see `boot.ts`). On the pages that DO
// hydrate, a move between screens changes the address without a request, and
// nothing outside the router knows it happened — so the router says so, once
// per navigation, through the one global the bundle publishes.
//
// It is one deliberate call rather than the tool's own automatic tracking,
// which has a known defect on this framework: it reports the full absolute
// address on a client-side navigation, splitting one page's count across two
// keys.

/** Whether this navigation should produce a page view. */
export function countsAsNavigation(type: string | null | undefined): boolean {
  // `enter` is the first render of the page the browser actually loaded. The
  // consent bundle sends that one itself, once the tracker exists, so counting
  // it here too would count every landing twice — and on a page with no
  // hydration there is no `enter` at all, which is the other half of the same
  // rule.
  return type !== "enter" && typeof type === "string" && type !== "";
}

/** The address a page view carries, as the browser has it now. */
export function currentPath(location: { pathname: string; search: string }): string {
  return `${location.pathname}${location.search}`;
}
